import { render } from "./nuevoPrograma.vue?vue&type=template&id=5381b697"
import script from "./nuevoPrograma.vue?vue&type=script&lang=js"
export * from "./nuevoPrograma.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__